function toDisplayPrice (value) {
  let returnPrice
  if (value !== undefined) {
    returnPrice = parseFloat(value).toFixed(2)

    returnPrice = returnPrice.replace('.', ',')
  } else {
    returnPrice = '0,00'
  }

  returnPrice = `€ ${returnPrice}`

  return returnPrice
}

function toDisplayPriceDelta (price) {
  let prefix = ''
  let returnPrice = Math.abs(parseFloat(price)).toFixed(2)

  returnPrice = returnPrice.replace('.', ',')

  prefix += price >= 0 ? '+ ' : '- '

  prefix += '€ '

  returnPrice = `${prefix}${returnPrice}`
  return returnPrice
}

export default {
  toDisplayPrice,
  toDisplayPriceDelta
}
